<template>
  <div>
    <h1>Devoluciones</h1>
    <b-modal ref="my-modal" hide-footer title="Realizar devolución">
      <div class="d-block text-center">
        <h3>¿Estás seguro(a) que deseas realizar la devolución?</h3>
            <b-button class="mt-2" variant="outline-warning" block @click="resetPassword(selected)" v-if="this.clicked === 0">Aceptar</b-button>
            <b-button class="mt-2" variant="outline-gray" block  v-else-if="this.clicked === 1">Cargando...</b-button>
            <b-button class="mt-2" variant="outline-success" block  v-else-if="this.clicked === 2">Devolución Exitosa</b-button>
            <b-button class="mt-2" variant="outline-danger" block  v-else-if="this.clicked === 3">Ha ocurrido un error</b-button>
      </div>
    </b-modal>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar conductor"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="card">
        <div class="card-body">
            <a-form>
                <div class="row">
                  <b-col md="11" class="my-1">
                    <b-form-group  class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="year" class="form-control" placeholder="Año" type="number"></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!year" @click="year = ''">Limpiar</b-button>
                        </b-input-group-append>
                      <b-button :disabled="!year" @click="getWithdrawYear" style="left: 20px; position: relative;">Buscar</b-button>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </div>
            </a-form>
        </div>
    </div>
    <b-table
      show-empty
      stacked="md"
      :items="getTripsDateRange"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      :key="tableIndex"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
    <template v-slot:cell(status)="row">
      <div :class="statusDictionary[row.item.status].class">{{ statusDictionary[row.item.status].label }}</div>
    </template>
    <template v-slot:cell(buttons)="row">
      <template v-if="row.item.status === 'PENDING'">
        <b-button class="btn-sm" variant="outline-warning" @click="showModal(row.item)">Realizar devolución</b-button>
      </template>
      <template v-else>
        <b-button class="btn-sm" variant="outline-info" >Devolución realizada</b-button>
      </template>
    </template>
    <!--totalTripAmount
      <template v-slot:cell(origin)='row' >
        <p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].origin}}</p>
      </template>
      <template v-slot:cell(destiny)='row' >
        <p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].destiny}}</p>
      </template> -->
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getTripsDateRange.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
import { notification } from 'ant-design-vue'
// import { useToast } from 'vue-toastification/composition'
// import { createToastInterface, POSITION } from 'vue-toastification'
const UPDATE_WITHDRAW = gql`
  mutation updateWithdraw($pk: String, $sk: String) {
    updateWithdraw(updateWithdrawInput: {pk: $pk, sk: $sk}){
      message
      success
    }
  }
`
const GET_WITHDRAW_DATE = gql`
  query getWithdrawDate($year:Int){
    getWithdrawDate(year: $year){
      pk
      sk
      newBalance
      date
      createdAt
      updatedAt
      transactionType
      transactionSource
      pocketTransactionType
      lastOne
      reciptEmail
      status
      accountable
      name
      amount
    }
  }
`
// const GET_WITHDRAW_NAME = gql`
//   query getWithdrawName($name:String){
//     getWithdrawName(name: $name){
//       pk
//       sk
//       newBalance
//       date
//       createdAt
//       updatedAt
//       transactionType
//       transactionSource
//       pocketTransactionType
//       lastOne
//       reciptEmail
//       status
//       accountable
//       name
//       amount
//     }
//   }
// `
export default {
  data() {
    return {
      counter: 0,
      getTripsDateRange: [],
      filteredItems: [],
      fields: [
        { key: 'pk', label: 'ID', sortable: true, sortDirection: 'desc' },
        { key: 'name', label: 'Conductor' },
        { key: 'reciptEmail', label: 'Correo' },
        { key: 'createdAt', label: 'Fecha de Solicitud' },
        { key: 'amount', label: 'Total a devolver' },
        { key: 'buttons', label: 'Acciones' },
        { key: 'status', sortable: true, label: 'Estatus' },
      ],
      autoRefresh: true,
      statusDictionary: {
        ACCEPTED_COMPLETED: { label: 'Pago exitoso', class: 'text-success font-weight-bold' },
        PENDING: { label: 'Pendiente', class: 'text-warning font-weight-bold' },
      },
      currentPageItemsAddresses: [],
      year: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      startDate: null,
      endDate: null,
      tableIndex: 0,
      clicked: 0,
      tripTypes: ['Aplicación', 'Todos', 'Sin Aplicación'], // 'Sin Aplicacion'],
      tripType: null,
    }
  },
  apollo: {
    getTripsDateRange: {
      query: gql`query getAllWithdraw{
          getAllWithdraw{
            pk
            sk
            name
            date
            reciptEmail
            createdAt
            updatedAt
            newBalance
            status
            amount
        }
      }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log(data.getAllWithdraw)
        this.getTripsDateRange = data.getAllWithdraw
        // var i = 0
        // data.getTripsDateRange.forEach(element => {
        //   var initTrial = element.startedAt
        //   if (initTrial.match('T')) {
        //     console.log(initTrial.slice(8, 10) + '/' + initTrial.slice(5, 7) + '/' + initTrial.slice(0, 4), initTrial.slice(-8), this.counter)
        //     data.getTripsDateRange[i].startedAt = initTrial.slice(8, 10) + '/' + initTrial.slice(5, 7) + '/' + initTrial.slice(0, 4) + ' ' + initTrial.slice(-8)
        //     console.log(element.finishedAt.slice(8, 10) + '/' + element.finishedAt.slice(5, 7) + '/' + element.finishedAt.slice(0, 4), element.finishedAt.slice(-8), this.counter)
        //     data.getTripsDateRange[i].finishedAt = element.finishedAt.slice(8, 10) + '/' + element.finishedAt.slice(5, 7) + '/' + element.finishedAt.slice(0, 4) + ' ' + element.finishedAt.slice(-8)
        //     i++
        //     // console.log('yes')
        //   }
        // })
        this.totalRows = data.getAllWithdraw.length
        // console.log(encrypt(new Date().getTime().toString()))
        /*
        if (data.getTripsDateRange) {
          data.getTripsDateRange.forEach(element => {

          })
          this.totalRows = data.getTripsDateRange.length
          this.getCurrentPageItems(this.getTripsDateRange)
        } */
      },
    },
  },
  watch: {
    /*
    currentPage: function() {
      if (this.filter) {
        this.getCurrentPageItems(this.filteredItems)
      } else {
        this.getCurrentPageItems(this.getTripsDateRange)
      }
    },
    */
  },
  methods: {
    closeModal() {
      this.$refs['my-modal'].hide()
    },
    showModal(selected) {
      this.$refs['my-modal'].show()
      this.selected = selected
      this.clicked = 0
    },
    resetPassword(selected) {
      // this.clicked = true
      console.log(selected.sk, selected.pk)
      this.clicked = 1
      this.$apollo.mutate({
        mutation: UPDATE_WITHDRAW,
        context: headers(),
        variables: { sk: selected.sk, pk: selected.pk },
      })
        .then(() => {
          // console.log(data)
          this.clicked = 2
          this.closeModal()
          notification.success({
            message: '',
            description: 'Se aprobo la devolución',
          })
        })
        .catch(error => {
          this.clicked = 3
          console.log(error)
        })
    },
    /*
    async getCurrentPageItems(items) {
      // console.log('Items per page')
      const firstIndex = (this.currentPage - 1) * 10
      const lastIndex = this.currentPage * 10
      const currentPageItems = items.slice(firstIndex, lastIndex)
      this.currentPageItemsAddresses = []
      for (const item of currentPageItems) {
        const origin = await this.getAddressFromCoords(item.pickUpLat, item.pickUpLng)
        const destiny = await this.getAddressFromCoords(item.destinationLat, item.destinationLng)
        this.currentPageItemsAddresses[item.id] = { origin: origin, destiny: destiny }
      }
      this.tableIndex += 1
      // console.log(this.currentPageItemsAddresses)
    },
    async getAddressFromCoords(lat, lng) {
      const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${lat},${lng}&key=AIzaSyB1VC22f38_ZxRfU2t5duK_kfChhXoKYF8`)
      return response.data.results[0].formatted_address
    },
    */
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant,
      })
    },
    onFiltered(filtered) {
      // console.log('filtered items')
      // console.log(filteredItems)
      // this.filteredItems = filtered
      this.totalRows = filtered.length
      this.currentPage = 1
      // this.getCurrentPageItems(this.filteredItems)
    },
    defineDate(date) {
      const dates = new Date(date)
      const year = (dates.getFullYear())
      var month = (parseInt(dates.getMonth() + 1))
      var day = (dates.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return [year, month, day].join('-')
    },
    changeStartDate(event) {
      if (event) {
        this.startDate = this.defineDate(event._d)
        // console.log(this.tripType)
        this.searchByType(this.tripType)
      } else {
        this.todayDate()
        // this.searchByType(this.tripType)
      }
    },
    changeEndDate(event) {
      if (event) {
        this.endDate = this.defineDate(event._d)
        this.searchByType(this.tripType)
      } else {
        this.todayDate()
        // this.searchByType(this.tripType)
      }
    },
    getWithdrawYear() {
      this.$apollo.query({
        query: GET_WITHDRAW_DATE,
        variables: {
          year: parseInt(this.year),
        },
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data.getWithdrawDate, 'gwd')
          this.totalRows = data.getWithdrawDate.length
          this.getTripsDateRange = data.getWithdrawDate
        })
        .catch(error => {
          console.log(error)
        })
    },
    todayDate() {
      // Use it
      const today = new Date()
      const year = (today.getFullYear())
      var month = (parseInt(today.getMonth() + 1))
      var day = (today.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      this.startDate = [year, month, day].join('-')
      this.endDate = [year, month, day].join('-')
    },
  },
  mounted() {
    this.todayDate()
  },
}
</script>
